import React, { useEffect, useState } from "react";
import cx from "classnames";
import t from "../../../utils/translate";
import Image from "../../Image";
import useAppContext from "../../AppContext";
import imageRefresh from "./imgs/loading.gif";

import styles from "./styles.module.scss";

export default function LoadingInterstitial() {
  const [visible, setVisible] = useState(true);
  const [elementVisible, setElementVisible] = useState(true);
  const delay = t("RESULTS_LOADING_TIMING") || 2000;

  const { newQuiz } = useAppContext();

  useEffect(() => {
    setTimeout(() => {
      setVisible(false);

      setTimeout(() => {
        setElementVisible(false);
      }, 600);
    }, delay);
  }, [delay]);

  return (
    <>
      {elementVisible && (
        <div
          className={cx(styles.container, {
            [styles.hidden]: !visible
          })}
        >
          <div className={styles.newQuizInner}>
            <div className={styles.newQuizHeader}>
              {newQuiz.isUni
                ? t("RESULTS_LOADING_HEADER_UNI")
                : t("RESULTS_LOADING_HEADER_NEW")}
            </div>
            {newQuiz.isSequence ? (
              <span className={styles.loadingIcon}></span>
            ) : (
              <Image
                className={styles.imageRebrand}
                src={imageRefresh}
                alt=""
              />
            )}
            <div className={styles.newQuizSubheader}>
              {newQuiz.eli
                ? t("RESULTS_LOADING_SUBHEADER_ELI")
                : newQuiz.isUni
                  ? t("RESULTS_LOADING_SUBHEADER_UNI")
                  : t("RESULTS_LOADING_SUBHEADER_NEW")}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
